import { Container } from "@bryntum/schedulerpro";

export default class UserEditorBase extends Container {
  static get $name() {
    return "UserEditorBase";
  }

  // Factoryable type name
  static get type() {
    return "usereditorbase";
  }
  static get configurable() {
    return {
      autoUpdateRecord: true
    };
  }

  editRecord(record, context, otherParams) {
    this.loading = true;
    this.loadRecord(record, context, otherParams);
    this.loading = false;
  }

  loadRecord(record, context) {
    this.record = record;
    this.context = context;
    Object.assign(this, context);
    this.swivuCheckGrants(context.user)
  }

  swivuCheckGrants() {}
}

UserEditorBase.initClass();
